export function createApi(httpClient) {
  function getDoubleOptInConfig(hash) {
    return httpClient.get("/crm/template/" + hash + "/double_opt_in");
  }
  return {
    getDoubleOptInConfig
  };
}